<template>
    <div class="cy-button" :class="class">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'cyButton',
        props: {
            class: {
                type: String,
                default: '',
            },
        },
    }
</script>

<style lang="scss">
.cy-button {
    width: 140px;
    height: 44px;
    background: #282828;
    border-radius: 25px;
    color: #fff;   
    padding: 10px 20px;
    text-align: center;

    &.cy-button--small {
        height: 32px;
        padding: 5px 12px;
        width: auto;
        padding: 5px 20px;
    }
    &:hover {
        cursor: pointer;
        background-color: rgb(40 40 40 / 90%);
    }
}
</style>